'use client';

import { HomePageBanner } from '@/models/HomePage';
import { differenceInSeconds, isFuture, parseISO } from 'date-fns';
import { useEffect, useState } from 'react';
import Countdown from './Countdown';
import OptimizedBannerListCarousel from './OptimizedBannerListCarousel';
import OptimizedBannerView from './OptimizedBannerView';

function pickActiveBanners(banners?: HomePageBanner[]): HomePageBanner[] {
  if (!banners?.length) return [];
  const match = banners.filter((b) => {
    if (!b?.badgeEndTime) return false;
    try {
      return isFuture(parseISO(b.badgeEndTime));
    } catch {
      return false;
    }
  });
  return match.length > 0 ? [match[0]] : banners;
}

export default function BannerlistWithBanner({
  banners,
  banner,
  dir,
  isPriority = false,
}: {
  banners?: HomePageBanner[];
  banner?: HomePageBanner;
  dir: string;
  isPriority?: boolean;
}) {
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [bannersFiltered, setBannersFiltered] = useState<HomePageBanner[]>(() =>
    pickActiveBanners(banners),
  );

  useEffect(() => {
    // Ana banner için bitiş tarihini ayarla
    if (banner && banner.badgeEndTime) {
      try {
        const bannerEndDate = parseISO(banner.badgeEndTime);
        if (differenceInSeconds(bannerEndDate, new Date()) > 10) {
          setEndDate(bannerEndDate);
        } else {
          setEndDate(null);
        }
      } catch (error) {
        console.error('Invalid date format for banner:', banner);
        setEndDate(null);
      }
    } else {
      setEndDate(null);
    }

    setBannersFiltered(pickActiveBanners(banners));
  }, [banner, banners]);

  return (
    <div className={`grid grid-cols-4 gap-4 max-w-7xl w-full mx-auto`} dir={dir}>
      <div className="col-span-4 md:col-span-3 h-full hover:cursor-pointer md:rounded-2xl">
        {isPriority ? (
          <OptimizedBannerView
            inCarousel={false}
            index={0}
            banner={(bannersFiltered?.[0] as HomePageBanner) || banner}
            isFirstBanner
            isPriority
            isLCP
          />
        ) : (
          <OptimizedBannerListCarousel banners={bannersFiltered} isPriority={false} />
        )}
      </div>

      {/* Sağ sütun: isPriority iken HİÇBİR GÖRSEL RENDER ETME (çift istek engeli) */}
      {!isPriority && endDate && (
        <div className="hidden md:flex col-span-1 h-full hover:cursor-pointer relative">
          <OptimizedBannerView
            banner={banner}
            inCarousel={false}
            index={0}
            isFirstBanner={false}
            isPriority={false}
            isLCP={false}
          />
          <div className="absolute bottom-20 left-10 max-sm:bottom-0">
            <Countdown endDate={endDate} transformOrigin="bottom left" hideHeader={true} />
          </div>
        </div>
      )}
    </div>
  );
}
